import { styled } from '@mui/system';
import { Button } from '@mui/material';

export const LooksGoodButton = styled(Button)({
    width: 'inherit',
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: '8px',
    backgroundColor: '#444',
    color: '#ffffff',
    '&:hover': {
        backgroundColor: '#555',
    },
});